import React from "react";

export const ReferralTableUserHeader = ({
  headOne,
  headTwo,
  headThree,
  headFour,
  headFive,
  headSix,
  headSeven,
  headEight,
  headNine,
  headTen,
  headEleven,
  headTwelve,
  headThirteen,
  headFourteen,
  headFifteen,
  headSixteen,
  selectedTab,
}) => {
  return (
    <React.Fragment>
      <tr>
        <th style={{ width: "10%" }}>{headOne}</th>
        <th style={{ width: "10%" }}>{headTwo}</th>
        <th style={{ width: "10%" }}>{headThree}</th>
        <th style={{ width: "10%" }}>{headFour}</th>
        <th style={{ width: "12%" }}>{headFive}</th>
        <th style={{ width: "14%" }}>{headSix}</th>
        <th style={{ width: "10%" }}>{headSeven}</th>
        <th style={{ width: "10%" }}>{headEight}</th>
        <th style={{ width: "10%" }}>{headNine}</th>
        {selectedTab === 5 && (
          <>
            <th style={{ width: "10%" }}>Type of Outlet</th>
            <th style={{ width: "10%" }}>Referred Date</th>
            <th style={{ width: "10%" }}>Enrollment Date</th>
            <th style={{ width: "10%" }}>Last Activity Date</th>
            <th style={{ width: "10%" }}>Payable Amount To Partner</th>
            <th style={{ width: "10%" }}>Receiving Org ID</th>
            <th style={{ width: "10%" }}>Receiving Org Name</th>
            <th style={{ width: "10%" }}>Amount Disburse to Udbhav</th>
          </>
        )}
        {selectedTab === 1 ||
          (selectedTab === 3 && (
            <>
              <th style={{ width: "10%" }}>{headTen}</th>
              <th style={{ width: "10%" }}>{headEleven}</th>
              <th style={{ width: "10%" }}>{headTwelve}</th>
              <th style={{ width: "10%" }}>{headThirteen}</th>
              <th style={{ width: "10%" }}>{headFourteen}</th>
              {selectedTab === 1 && (
                <>
                  <th style={{ width: "10%" }}>{headFifteen}</th>
                  <th style={{ width: "10%" }}>{headSixteen}</th>
                </>
              )}
            </>
          ))}
      </tr>
    </React.Fragment>
  );
};
